import React, { useState, useEffect } from 'react';
import { Nav, Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './responsive-nav-tabs.css';

const ResponsiveNavTabs = ({ activeTab = 0, tabNames = [], children = null, setActiveTab, forceSelect = false, size = 'sm', breakpoint = 768 }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < parseInt(breakpoint);

  // Navigation Mobile : Boutons Précédent / Suivant
  const handlePrev = () => {
    setActiveTab((prev) => (prev > 0 ? prev - 1 : tabNames.length - 1));
  };

  const handleNext = () => {
    setActiveTab((prev) => (prev < tabNames.length - 1 ? prev + 1 : 0));
  };

  return (
    <Row className="responsive-nav-tabs align-items-center" >
      <Col>
        {isMobile || forceSelect ? (
          <div className="d-flex mobile-ui">
            <InputGroup className="me-auto mb-2">
              <Button variant="outline-secondary" onClick={handlePrev}>
                <FaChevronLeft />
              </Button>
              <Form.Select
                size={size}
                value={activeTab}
                onChange={event => setActiveTab(parseInt(event.target.value, 10))}
                className="form-control"
              >
                {tabNames.map((name, index) => (
                  <option key={index} value={index}>{name}</option>
                ))}
              </Form.Select>
              <Button variant="outline-secondary" onClick={handleNext}>
                <FaChevronRight />
              </Button>
            </InputGroup>
            {children && <div className='ms-3 d-flex justify-content-end align-items-center'>{children}</div>}
          </div>
        ) : (
          <Nav variant="tabs" activeKey={activeTab.toString()} onSelect={idx => setActiveTab(parseInt(idx))}>
            {tabNames.map((name, index) => (
              <Nav.Item key={index}>
                <Nav.Link eventKey={index.toString()}>{name}</Nav.Link>
              </Nav.Item>
            ))}
            {children && <div className='flex-grow-1 d-flex justify-content-end align-items-center'>{children}</div>}
          </Nav>
        )}
      </Col>
    </Row>
  );
};

export default ResponsiveNavTabs;
